import { Input, Component, EventEmitter, Output } from '@angular/core';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'eiq-interactive-dropdown-item',
  templateUrl: './interactive-dropdown-item.component.html',
  styleUrls: ['./interactive-dropdown-item.component.scss']
})
export class InteractiveDropdownItemComponent {
  @Input() selected = false;
  @Output() clicked = new EventEmitter<void>();

  faCheck = faCheck;
}
